<!--
 * @Author: Junjie
 * @Date: 2022-11-18 13:52:25
 * @LastEditTime: 2022-12-27 21:29:15
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/category/modules/CommonCategoryModal.vue
-->
<template>
  <j-modal
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model :model="model" :rules="validatorRules" ref="form">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="父级节点" prop="pid">
          <j-tree-select
            :disabled="disabled"
            dict="`iwt-wf`.common_category,name,id"
            pidField="pid"
            pidValue="0"
            placeholder="请选择父级节点"
            ref="treeSelect"
            v-model="model.pid"
          ></j-tree-select>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称" prop="name">
          <a-input v-model="model.name"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自定义属性1" prop="cusProp1">
          <a-textarea :rows="4" v-model="model.cusProp1"></a-textarea>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自定义属性2" prop="cusProp2">
          <a-textarea :rows="4" v-model="model.cusProp2"></a-textarea>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自定义属性3" prop="cusProp3">
          <a-textarea :rows="4" v-model="model.cusProp3"></a-textarea>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否启用" prop="enable">
          <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-model="model.enable" />
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序" prop="sortNo">
          <a-input-number placeholder="请输入排序数字" style="width: 100%" v-model="model.sortNo" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import JTreeSelect from '@/components/jeecg/JTreeSelect'

  export default {
    name: "CommonCategoryModal",
    components: {
      JTreeSelect
    },
    data () {
      return {
        title: "操作",
        width: 800,
        visible: false,
        model: {
          enable: true
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules: {
          pid: {},
          name: [{ required: true, message: '请输入名称!' }]
        },
        url: {
          add: "/custom/category/add",
          edit: "/custom/category/edit",
          checkCode: "/custom/category/checkCode",
        },
        expandedRowKeys: [],
        pidField: "pid",
        subExpandedKeys: []

      }
    },
    created () {
    },
    computed: {
      disabled () {
        return this.model.id ? true : false;
      }
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.resetFields();
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            this.model.enable = this.model.enable ? 1 : 0;
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                // close的时候清空了表单的值 导致model为空 修改值在列表页没有变 此处需要复制一下model
                that.submitSuccess({ ...this.model })
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }

        })
      },
      handleCancel () {
        this.close()
      },
      submitSuccess (formData) {
        if (!formData.id) {
          let treeData = this.$refs.treeSelect.getCurrTreeData()
          this.expandedRowKeys = []
          this.getExpandKeysByPid(formData[this.pidField], treeData, treeData)
          if (formData.pid && this.expandedRowKeys.length == 0) {
            this.expandedRowKeys = this.subExpandedKeys;
          }
          this.$emit('ok', formData, this.expandedRowKeys.reverse());
        } else {
          this.$emit('ok', formData);
        }
      },
      getExpandKeysByPid (pid, arr, all) {
        if (pid && arr && arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].key == pid) {
              this.expandedRowKeys.push(arr[i].key)
              this.getExpandKeysByPid(arr[i]['parentId'], all, all)
            } else {
              this.getExpandKeysByPid(pid, arr[i].children, all)
            }
          }
        }
      },

    }
  }
</script>